<template>
  <div class="is-block pl-0-touch pl-0" :class="chapter.level === 1 ? 'parent-node' : ''">
    <div :class="'is-flex is-align-items-center pl-'+ chapter.level + getParentClassStyle(chapter.level)" style="width: 100%;">
      <div class="is-full" style="width: 100%">
        <div :class="'is-flex is-justify-content-space-between has-text-black' + getParentClassStyleHeaderText(chapter.level)" style="padding: 0.8em; font-size: 0.90rem;">
          <div class="is-flex">
            <div class="pr-1" :class="isFolder && isExpandable ? 'is-clickable' : ''" @click="toggle">
              <i v-show="isFolder && !isOpen && isExpandable" class="fa fa-angle-down" aria-hidden="true"></i>
              <i v-show="isFolder && isOpen && isExpandable" class="fa fa-angle-up" aria-hidden="true"></i>
              <i v-show="!isFolder || !isExpandable" class="fa fa-angle-down is-invisible" aria-hidden="true"></i>
            </div>
            <div v-if="!watching_icons_and_links_enabled">
              {{ (chapter.number ? chapter.number + ' - ' : '') + chapter.name }}
              <span v-if="chapter.subtitle" style="color: #99cc00">{{ chapter.subtitle }}</span>
            </div>
            <div v-if="watching_icons_and_links_enabled" :class="getCurrentlyWatchedChapterStyle(chapter, first_active_slug)">
              <a :class="getCurrentlyWatchedChapterStyle(chapter, first_active_slug)" :href="chapter.chapter_url">
                {{ (chapter.number ? chapter.number + ' - ' : '') + chapter.name }}
                <span v-if="chapter.subtitle" style="color: #99cc00">{{ chapter.subtitle }}</span>
              </a>
              <i v-if="!chapter.is_completed && !chapter.is_active && chapter.slug !== first_active_slug  && !chapter.is_skippable || chapter.is_completed_course && !chapter.can_be_rewatched && !chapter.is_skippable" class="fa fa-lock is-locked"></i>
              <i v-if="chapter.is_active" class="fa fa-eye"></i>
            </div>
          </div>
          <div style="font-weight: normal">
            <span v-html="getChapterDuration(chapter, isFolder, isOpen)"></span>
          </div>
        </div>
      </div>
    </div>
    <transition
      name="syllabus-slide"
      @enter="animationStart"
      @after-enter="animationEnd"
      @before-leave="animationStart"
      @after-leave="animationEnd"
    >
      <div v-show="isOpen && isFolder" style="margin-bottom: 1px">
        <syllabus-chapters-tree-child-node
          v-for="child in chapter.children"
          :key="child.slug"
          :chapter="child"
          :first_active_slug="first_active_slug"
          :watching_icons_and_links_enabled="watching_icons_and_links_enabled"
        ></syllabus-chapters-tree-child-node>
      </div>
    </transition>
  </div>
</template>

<style>
  .parent-node {
    margin-bottom: -1px; /*fixes double borders*/
  }
  .parent-node:last-child {
    margin-bottom: -2px; /*fixes double borders*/
  }
  .parent-syllabus-chapter {
    background-color: #f7f9fa;
    border: 1px solid #d1d7dc;
  }
  .parent-syllabus-chapter-text-bold {
    font-weight: bold;
  }
  .child-syllabus-chapter {
    background-color: white;
    border-left: 1px solid #d1d7dc;
    border-right: 1px solid #d1d7dc;
  }
  .syllabus-slide-enter-active,
  .syllabus-slide-leave-active {
    will-change: height, opacity;
    transition: height 0.3s ease, opacity 0.3s ease;
    overflow: hidden;
  }
  .syllabus-slide-enter,
  .syllabus-slide-leave-to {
    height: 0 !important;
    opacity: 0;
  }
</style>

<script>
export default {
  name: 'SyllabusChaptersTreeChildNode',
  props: {
    chapter: { type: Object, required: true, default: null },
    first_active_slug: { type: String, required: false, default: null },
    watching_icons_and_links_enabled: { type: Number, required: false, default: 0 }
  },

  data() {
    let is_open = null;
    if (this.watching_icons_and_links_enabled) {
      let should_be_open = true;
      if (this.chapter.expandable) {
        should_be_open = this.isActiveOrHasActiveChild(this.chapter);
      }
      is_open = should_be_open;
    } else {
      is_open = !this.chapter.expandable;
    }
    return {
      isOpen: is_open
    };
  },

  computed: {
    isFolder() {
      return this.chapter.children && this.chapter.children.length;
    },

    isExpandable() {
      return this.chapter.expandable;
    }
  },
  methods: {
    toggle() {
      if (this.isFolder && this.isExpandable) {
        this.isOpen = !this.isOpen;
      }
    },

    getParentClassStyle(level) {
      return (level === 1) ? ' parent-syllabus-chapter' : ' child-syllabus-chapter';
    },

    getParentClassStyleHeaderText(level) {
      return (level === 1) ? ' parent-syllabus-chapter-text-bold' : '';
    },

    getCurrentlyWatchedChapterStyle(chapter, first_active_slug) {
      if (!chapter.is_completed && !chapter.is_active && chapter.slug !== first_active_slug) {
        return 'has-text-grey-light';
      } else if (chapter.is_active) {
        return 'has-text-blue';
      } else {
        return 'has-text-black';
      }
    },

    getChapterDurationFormatted(seconds) {
      if (seconds) {
        return seconds2time(seconds, true);
      } else {
        return '-';
      }
    },

    getChapterDuration(chapter, isFolder = '', isOpen) {
      const seconds = this.getChapterDurationInSeconds(chapter, isFolder, isOpen);
      return this.getChapterDurationFormatted(seconds);
    },

    getChapterDurationInSeconds(chapter, isFolder = '', isOpen) {
      let duration = 0;
      if (chapter.hours || chapter.minutes || chapter.seconds) {
        duration += chapter.hours * 3600 + chapter.minutes * 60 + chapter.seconds;
      }
      if (isFolder && chapter.children && chapter.expandable && !isOpen) {
        chapter.children.forEach(child => {
          duration += this.getChapterDurationInSeconds(child, isFolder);
        });
      }
      return duration;
    },
    animationStart(el) {
      el.style.height = el.scrollHeight + 'px';
    },
    animationEnd(el) {
      el.style.height = '';
    },
    isActiveOrHasActiveChild(chapter) {
      let has_active = false;
      if (chapter.is_active) {
        has_active = true;
      } else {
        if (chapter.children && chapter.children.length) {
          chapter.children.forEach(child => {
            if (!has_active) {
              has_active = this.isActiveOrHasActiveChild(child);
            }
          });
        }
      }
      return has_active;
    }
  }
};
</script>
